<div class="flex justify-content-end align-items-center gap-2 mt-4 w-full mb-4 flex-wrap">
  <div class="flex gap-2 justify-content-end">
    <button miButton="back" [miButtonIcon]="'solar:add-circle-broken'" (click)="openModalCreate()">Agregar (opcional)</button>
  </div>
</div>
<div class="grid mt-2 mb-4">
  <div class="grid">
    <!-- Panel informativo -->
    <div class="col-12 md:col-3">
      <div class="grid">
        <div class="col-12">
          <div class="p-3 border-round surface-50">
            <p class="text-sm font-bold text-color-secondary m-0 mb-3">
              Sube documentos para agilizar tu proceso (opcional) <br>
              Si tienes disponibles los siguientes documentos, cárgalos ahora desde esta opción, si no, podrás cargarlos más adelante.
            </p>
            <div class="text-sm text-600">
              @for (doc of tiposDocumentosSugeridos; track $index) {
                <span>* {{ doc.label }}</span><br />
              }
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Tabla -->
    <div class="col-12 md:col-9">
      <!-- Opcional: card contenedor para mejor padding en móvil -->
      <div class="w-full">
        <p-table [value]="filesToShow" class="w-full" dataKey="id" responsiveLayout="scroll" [breakpoint]="'768px'">
          <ng-template pTemplate="header">
            <tr>
              <th style="width: 40%">Documento</th>
              <th style="width: 40%">Tipo de documento</th>
              <th style="width: 10%"></th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-file let-rowIndex="rowIndex">
            <tr>
              <td>
                <div class="w-full" style="width: 100%">
                  <div>{{ file.name }}</div>

                  @if (file.size != '' && file.id === '') {
                  <div><b>{{ file.size / 1024 | number: '1.2-2' }} KB</b></div>
                  } @if (file.id === '') {
                  <p-tag severity="primary" class="mb-2 bg-primary-color">Nuevo</p-tag>
                  } @if (file.indSignProcess) {
                  <p-tag severity="warn" class="mb-2">En proceso de firma</p-tag>
                  } @if (file.dateDownloadSign != null) {
                  <p-tag severity="success" class="mb-2">Firmado</p-tag>
                  <div><b>{{ file.dateDownloadSign | date: 'dd/MM/yyyy' }}</b></div>
                  } @if (!file.indSignProcess && file.id !== '' && file.dateDownloadSign == null) {
                  <p-tag severity="secondary" class="mb-2">Cargado</p-tag>
                  }
                </div>
              </td>

              <td>
                @if (file.id === '') {
                <div [miCol]="12"  class="m-0" miFormField [miFormFieldError]="file.tipo == '' ? 'Tipo de documento requerido' : null">
                  <label for="tipo">Tipo de documento *</label>
                  <p-select
                    id="tipo"
                    [filter]="true"
                    [filterPlaceholder]="'Buscar tipo de documento...'"
                    [filterBy]="'label'"
                    [(ngModel)]="file.tipo"
                    [options]="tiposDocumentos"
                    optionLabel="label"
                    optionValue="id"
                    placeholder="Seleccione un tipo de documento"
                    [appendTo]="'body'"
                    class="w-full"
                  >
                    <ng-template let-option #item> {{ option.label | titlecase }} </ng-template>
                    <ng-template let-selectedOption #selectedItem> {{ selectedOption.label | titlecase }} </ng-template>
                  </p-select>
                </div>
                } @else {
                <div class="w-full">
                  <div>{{ searchTypeDocument(file.tipo.toString()) }}</div>
                </div>
                }
              </td>

              <td class="text-center">
                <div class="flex justify-content-center gap-2 md:gap-2 ">
                  @if (file.id === '') {
                  <p-button
                    type="button"
                    class="p-button-rounded p-button-text"
                    variant="outlined"
                    [pTooltip]="'Eliminar fila'"
                    (click)="removeFile(rowIndex)"
                    title="Descartar fila"
                  >
                    <i class="iconify icon-18" [attr.data-icon]="'solar:minus-circle-broken'"></i>
                  </p-button>
                  } @if (file.id !== '' && file.useSign) {
                  <button
                    pButton
                    type="button"
                    class="p-button-rounded p-button-text"
                    variant="outlined"
                    [pTooltip]="'Enviar firma electrónica'"
                  >
                    <i class="iconify icon-18" [attr.data-icon]="'solar:plain-2-broken'"></i>
                  </button>
                  } @if (file.id !== '') {
                  <button
                    pButton
                    type="button"
                    class="p-button-rounded p-button-text"
                    variant="outlined"
                    [pTooltip]="'Ver archivo'"
                    (click)="getDocument(file.id, file.name)"
                  >
                    <i class="iconify icon-18" [attr.data-icon]="'solar:eye-broken'"></i>
                  </button>
                  <button
                    pButton
                    type="button"
                    class="p-button-rounded p-button-text danger-color"
                    variant="outlined"
                    [pTooltip]="'Borrar archivo'"
                    (click)="deleteFile(rowIndex, file.id)"
                  >
                    <i class="iconify icon-18" [attr.data-icon]="'solar:trash-bin-minimalistic-broken'"></i>
                  </button>
                  }
                </div>
              </td>
            </tr>
          </ng-template>

          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="3" class="text-center"><i>No hay documentos cargados</i></td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
  </div>
</div>
